export default __webpack_public_path__ + "static/media/getRichNaval.03dcc7ca.jpg";